<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/router/views_mobagile/components/loader.vue";
import api from "@/axios";
import moment from "moment/moment";
import { useMagicKeys, whenever } from '@vueuse/core'
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Editar Inventário",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Loader, Layout, PageHeader, Multiselect },
  data() {
    return {
      title: "Editar Inventário",
      items: [
        {
          text: "Inventários",
          href: "/movinvents/list",
        },
        {
          text: "Editar Inventário",
          active: true
        }
      ],

      idData: 0,
      updating: true,
      updatingListas: false,
      wmsOsListData: null,
      movInventsData: [],
      movInventData: {
        id: 0,
        status: "EL",
        dtemissao: new Date,
        tipo: "soma",
        tipoconf: 'A',
        tipoendwms: 'A',
        deflote: 'A',
        defvalid: 'A',
      },

      movInventItemData: {},
      movInventItensData: {},

      wmsOsItemData: {},

      submitted: false,
      errosValid: null,
      enderecoData: null,
      dtlistPesqEndereco: null,

      dtListProdSugest: null,
      updatingPesqProd: false,

      activeStep: 1,
      tamanhoTela: 0,
      showConfManual:false,
      n:false,
      showListInvents: false,
      showListConfiguracoes: false,
      showItensInvent: false,
      selectedItem: null,
      showModalErros: false,
      dtListErrors: [],
      disableButton: false
    }
  },

  created() {
  },

  mounted() {
    console.log('mounted_inventatio_coletor_0')
    this.tamanhoTela = window.innerWidth
    const keys = useMagicKeys()

    whenever(keys.alt_s, () => {
      this.$refs.produto.focus()
    })

    whenever(keys.alt_r, () => {
      this.reiniciar()
    })

    whenever(keys.alt_z, () => {
      this.finalizar()
    })
    console.log('mounted_inventario_editar')
    let rota = this.$route.path
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    if(this.idData > 0){

      this.movInventData.id = this.idData
      this.carregarInvent()
    } else{
      this.carregarDados()
    }
  },

  methods: {

    goToStep(step){
      console.log('goToStep', step)
      this.activeStep = step;

      this.$nextTick(() => {
        if(step === 1){
          this.$refs.inventID.focus()
        } else if(step === 2) {
          this.movInventItemData.endwms = null
          this.$refs.endwms.focus()
        } else if(step === 3) {
          if (this.movInventData.deflote === 'A'){
            this.$refs.lote.focus()
          } else {
            this.informouLote()
          }
        }
      })
    },

    informouID() {
      console.log('informouID')

      if (this.informaId !== null) {
        this.idData = this.informaId

        this.$router.push(`/coletor/inventariocoletor/${this.idData}`)
      } else {
        this.showInformaInventId = true
      }


      if (this.idData > 0){
        this.carregarDados()
      }else{
        this.title = `Criando Novo Inventário`
        this.updating = false
      }
      this.informaId = null
      this.showInformaInventId = false

      this.$refs.endwms.focus()
    },

    salvar() {
      console.log('salvar')

      if (this.movInventData.status === "EL") {
        this.updatingListas = true
        api.post(`${getBaseUrl()}api/movinvent`, {
          movinventdata: this.movInventData,
          movinventitemdata: this.movInventItemData
        }).then((res) => {
          console.log('then axios salvar')
          console.log(JSON.stringify(res.data))
          if(!res.data.success) {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: res.data.message,
              showConfirmButton: false,
              timer: 1500
            })
          } else {

            if(this.movInventData.id > 0 ) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.carregarDados()
              })
            } else  {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: 'Novo Inventário criado com sucesso!',
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.movInventData = res.data.movinvent
                this.movInventItemData = res.data.movinventitem
                this.carregarInvent()
              })
            }

          }
        })
      }
    },

    selecionarPesq(dataProd){
      console.log('selecionarPesq')
      this.movInventItemData.produto = dataProd.codigo
      this.movInventItemData.descprod = dataProd.descricao
      this.$refs.produto.focus()
    },

    editarProd(prod) {
      console.log('editarProd')

      this.movInventItemData.id = prod.id
      this.movInventItemData.endwms = prod.endwms
      this.movInventItemData.produto = prod.produto
      this.movInventItemData.descprod = prod.descprod

      this.$refs.qtd.focus()

      this.dtlistPesqEndereco = [
        {
          'codigo': prod.endwms,
          'descricao': prod.endwms
        },
      ]
    },

    deletarItem(dataID) {
      console.log('deletarItem')

      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {

          this.updating = true
          api.delete(`${getBaseUrl()}api/movinventitem`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })

    },

    informouQtd() {
      console.log('informouQtd')
      console.log(this.movInventItemData)
      console.log(JSON.stringify(this.movInventItemData))
      this.movInventItemData.empresa = this.movInventData.empresa

      if (this.movInventItemData.produto && this.movInventItemData.endwms) {

        this.updatingListas = true
        api.post(`${getBaseUrl()}api/movinventitem`, {
          'iddata': this.idData,
          'movinventdata': this.movInventData,
          'item': this.movInventItemData
        }).then((res) => {
          console.log('then axios confitem')
          console.log(this.idData)
          console.log(res.data)
          this.updatingListas = false

          if (this.idData === 0){
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Inventário iniciado com sucesso!",
              showConfirmButton: false,
              timer: 2000
            }).then(() => {
              this.idData = res.data[0][0].movinvent_id
              this.$router.replace('/movinvent/editar/' + this.idData)
            })
          }

          this.movInventData.nome_empresa = res.data[1].emprnome

          this.movInventItensData = res.data[0]
          this.movInventItemData.produto = null
          this.movInventItemData.descprod = null
          this.movInventItemData.qtd = null
          this.dtListProdSugest = null
          this.$refs.produto.focus()
        })

      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Obrigatório informar produto, endereço e  quantidade, favor corrigir.",
          showConfirmButton: false,
          timer: 2500
        })
      }
    },

    pesqEndereco(evt) {
      console.log('pesqEndereco')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        // this.loadingPedTipo = true
        // this.wmsOsItemSepData.endwms = ''
        api.get(`${getBaseUrl()}api/enderpes`, {
          params: { q: query, origem: "movinvent", origem_id: this.movInventData.id }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqEndereco = res.data
        })
      }
    },

    escolheuEndereco() {
      console.log('escolheuEndereco')
      console.log(this.movInventItemData.endwms)

      if(this.movInventItemData.endwms) {
        api.get(`${getBaseUrl()}api/wmsenddesc`, {
          params: { descdata: this.movInventItemData.endwms }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          if(res.data.success === true) {

            if(this.movInventItemData.endwms){
              this.goToStep(3)
            } else {
              Swal.fire({
                position: "top-end",
                icon: "warning",
                title: "Nenhum endereço definido, favor conferir endereço informado.",
                showConfirmButton: false,
                timer: 2500
              })
            }
          } else {
            Swal.fire({
              position: "center",
              icon: "warning",
              title: res.data.message,
              showConfirmButton: false,
              timer: 2500
            })
          }
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhum endereço definido, favor conferir endereço informado.",
          showConfirmButton: false,
          timer: 2500
        })
      }
    },

    finalizar() {
      console.log('finalizar')
      if (this.movInventItensData.length > 0) {

        Swal.fire({
          position: "center",
          icon: "question",
          title: "Finalizar Conferência",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.updating = true

            // console.log(result.value)
            // console.log('vai')
            // this.wmsOsItemData['idwmsos'] = this.idData
            // this.updatingListas = true
            //
            api.post(`${getBaseUrl()}api/movinventfinalsep`, {
              'iddata': this.idData
            }).then((res) => {
              console.log('then axios separar2_0')
              console.log(res.data)
              this.movInventData = res.data[0]
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Comando Finalizar executado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
              this.updating = false
            })
          }
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Necessário adicionar item ao inventário, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    /*reiniciarInvent() {
      console.log('reiniciarInvent')

      Swal.fire({
        position: "center",
        icon: "question",
        text: "Esta operação é irreversível, deseja continuar?",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          console.log('vai excluir itens de movinventitem e zerar valores de movinvent')

          api.post(`${getBaseUrl()}api/movinventreinicia`, {
            iddata: this.idData,
          }).then((res) => {
            console.log('then axios salvar')
            console.log(res.data)

            if (res.data.success) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Comando Reiniciar executado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.carregarDados()
              })
            }
          })
        }
      })

      /!*this.$router.push(`/coletor/inventariocoletor/0`).then((blankWmsos) => {
        window.open(blankWmsos, '_self')
        this.atualizaPagina()
      })*!/
    },*/

    reiniciar(){
      console.log('reiniciar')

      this.$router.push(`/coletor/inventariocoletor/0`)
      this.carregarDados()
    },

    confirmarInvent() {
      console.log('confirmarInvent')
      this.closedModalConfig()
      Swal.fire({
        position: "center",
        icon: "question",
        text: "Esta operação é irreversível, deseja continuar?",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          console.log('finalizar inventario')

          api.post(`${getBaseUrl()}api/movinventfinaliza`, {
            iddata: this.idData,
          }).then((res) => {
            console.log('then axios finaliza invent')
            console.log(res.data)

            if(!res.data.success) {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Erro ao finalizar Inventário!",
                showConfirmButton: false,
                timer: 2500
              }).then(() => {
                this.carregarDados()
              })
            } else {

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Inventário finalizado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              }).then(() => {

                this.idData = 0
                this.movInventData.id = 0
                this.activeStep = 1
                this.movInventData = {
                  id: 0,
                  status: "EL",
                  dtemissao: new Date,
                  tipo: "soma",
                  tipoconf: 'A',
                  tipoendwms: 'A',
                  deflote: 'A'
                }
                this.movInventItemData = {}

                this.$router.push(`/coletor/inventariocoletor/0`)
                this.carregarDados()
              })

              if(res.data.errosSaidas.length > 0) {
                this.dtListErrors = res.data.errosSaidas
                this.showModalErros = true
              }
            }
          })
        }
      })
    },

    atualizaPagina() {
      window.location.reload();
    },

    informouLote(){
      console.log('informouLote')

      if(this.movInventData.defvalid === 'A') {
        this.$refs.valid.focus()
      } else {
        this.$refs.produto.focus()
      }

    },

    informouValid(){
      console.log('informouLote')

      this.$refs.produto.focus()
    },

    informouProduto() {
      console.log('informouProduto')
      if(this.disableButton){
        Swal.fire({
          'position': 'center',
          'icon': 'warning',
          'title': 'Aguarde',
          'timer': 1000
        })
        return
      }

      this.disableButton = true
      console.log(this.movInventItemData.produto)
      this.updatingPesqProd = true
      if (this.movInventItemData.produto) {
        api.get(`${getBaseUrl()}api/prodcodcoletor`, {
          params: {
            coddata: this.movInventItemData.produto,
            empresa: this.movInventData.empresa
          }
        }).then((res) => {
          console.log('then axios prodcod')
          console.log(res.data)

          this.updatingPesqProd = false

          if(res.data.success === true) {
            let produtoModel = []
            produtoModel.push({
              produto_id: res.data.data.id,
              descprod: res.data.data.descricao,
              saldo: res.data.data.saldo ?? 0,
              empresa: res.data.data.emprid,
              produto: res.data.data.codigo,
              endwms: this.movInventItemData.endwms,
              lote: this.movInventItemData.lote,
              dtvalid: this.movInventItemData.dtvalid,
            })

            this.movInventItemData = produtoModel[0]

            if (this.movInventItemData.descprod && this.movInventItemData.endwms && this.movInventData.tipoconf === 'A') {

              this.informouQtd()
              this.disableButton = false

            } else {

              this.$refs.qtd.focus()
              this.disableButton = false
            }
          } else {

            this.movInventItemData.descprod = null
            this.movInventItemData.id = null

            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: res.data.message,
              showConfirmButton: false,
              timer: 1500
            })
            this.disableButton = false
          }
        })
      }
    },

    carregarDados(){
      console.log('carregarDados')

      api.get(`${getBaseUrl()}api/movinvetcoletor`, {
        params: {
          iddata: this.idData
        }
      }).then((res) => {
        console.log('then axios movinvent coletor')
        console.log(res.data)

        if(res.data.data[0].length > 0) {
          this.movInventData = res.data.data[0]
        }

        if(res.data.data[1].length > 0) {
          this.movInventItensData = res.data.data[1]
        }

        if(res.data.data[2].length > 0) {
          this.movInventsData = res.data.data[2]
        }

        this.updating = false
        if(this.idData > 0){
          this.idData = this.movInventData.id
          this.goToStep(2)

        } else if(this.tamanhoTela < 500) {
          this.$nextTick(() => {
            this.$refs.inventID.focus()
          }, 500)
        } else {
          this.$nextTick(() => {
            this.$refs.endwms.focus()
          }, 500)
        }
      })
    },

    clicouInvent(idInvent) {
      console.log('clicouInvent')

      this.showListInvents = false
      this.movInventData.id = idInvent;

      this.$nextTick(() => {
        this.$refs.inventID.focus()
      }, 500)
    },

    carregarInvent() {
      if(!this.movInventData.id){
        Swal.fire({
          position: "top-end",
          icon: "question",
          title: "Deseja criar novo inventario?",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.salvar()
          }
        })
      } else {
        api.get(`${getBaseUrl()}api/movinvetcoletor`, {
          params: {
            iddata: this.movInventData.id
          }
        }).then((res) => {
          console.log('then axios wmsosindividual')
          console.log(res.data)

          if(!res.data.success){
            Swal.fire({
              position: "center",
              icon: "error",
              title: res.data.message,
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2500
            })
          }else{
            this.movInventData = res.data.data[0]
            this.idData = this.movInventData.id

            this.$router.push(`/coletor/inventariocoletor/${this.movInventData.id}`)
            this.carregarDados()
          }
        })
      }
    },

    clicouProduto(codProd) {
      console.log('clicouProduto' , codProd)

      this.showItensInvent = false
      this.movInventItemData.produto = codProd;

      this.$nextTick(() => {
        this.$refs.produto.focus()
      }, 500)
    },

    onModalClosed() {
      console.log('onModalClosed')
      this.showItensInvent = false

      this.$nextTick(() => {
        if(this.activeStep === 2) {
          this.$refs.endwms.focus()
        } else if(this.activeStep === 3) {
          this.$refs.produto.focus()
        }
      }, 500)
    },

    closedModalConfig() {
      console.log('closedModalConfig')
      this.showListConfiguracoes = false

      this.$nextTick(() => {
        if(this.activeStep === 1) {
          this.$refs.inventID.focus()
        } else if(this.activeStep === 2) {
          this.$refs.endwms.focus()
        } else if(this.activeStep === 3) {
          this.$refs.produto.focus()
        }
      }, 500)
    },

    retornaParaInputInvent(){
      console.log('retornaParaInputInvent')

      this.idData = 0
      this.movInventData.id = 0
      this.activeStep = 1
      this.movInventData = {
        id: 0,
        status: "EL",
        dtemissao: new Date,
        tipo: "soma",
        tipoconf: 'A',
        tipoendwms: 'A',
        deflote: 'A'
      }
      this.movInventItemData = {}

      this.$router.push(`/coletor/inventariocoletor/0`)
      this.carregarDados()
    },

    abrirShowConfManual() {
      console.log('abrirshowConfManual')
      this.showConfManual = true
    },

    onModalConfManual() {
      this.$refs.qtdlida.focus()
    },

    abrirShowListInvent() {
      console.log('abrirShowListInvent')

      if(this.idData === 0) {
        this.showListInvents = true
      } else {
        this.showItensInvent = true
      }
    },

    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
          !document.fullscreenElement &&
          /* alternative standard method */ !document.mozFullScreenElement &&
          !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
              Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },

    nomeStatusInvent(stsIn){
      let result = 'Não Conferido'
      switch (stsIn) {
        case 'FE':
          result = 'Finalizado'
          break
        case 'EL':
          result = 'Elaboração'
          break
      }
      return result
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },
  },

};
</script>
<template>
  <div v-if="tamanhoTela > 500">
    <Layout>
      <PageHeader :title="title" :items="items"/>

      <Loader v-if="updating" style="min-height: 400px;">
      </Loader>


      <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
        <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
        favor ajustar e tentar novamente.
      </b-alert>

      <div class="col-xl-8" v-if="!updating">
        <div class="card">
          <div class="card-body">
            <h5 class="mx-2 mb-4"><span class="text-trucad font-size-14 me-1">Empresa:  </span>{{this.movInventData.nome_empresa ?? "Não Definida"}}</h5>
            <div class="d-flex align-items-start">
              <b-button variant="outline-primary" class="mx-2" @click="salvar" :disabled="movInventData.status !== 'EL'">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar
              </b-button>

              <b-button variant="outline-primary" class="mx-2" @click="atualizaPagina" :disabled="this.movInventItemData?.length > 0">
                <i class="bx bx-sync font-size-16 align-middle me-2"></i>
                Reloader (alt + R)
              </b-button>

              <button class="btn btn-success" :disabled="movInventData.status !== 'EL' && idData  > 0" @click="finalizar">
                <i class="mdi mdi-check me-1 text-end"></i>
                Finalizar (alt + Z)
              </button>
            </div>
          </div>

          <div class="card-body">
            <div class="col-sm-4">
              <div class="mb-3">
                <label for="tipo">Tipo de inventário</label>
                <select id="tipo" v-model="movInventData.tipo" class="form-control"
                        :disabled="movInventData.status !== 'EL'">
                  <option value="sobrepor">Sobreposição (Zera histório e recomeça com inventário)</option>
                  <option value="soma">Soma (Acréscimo ao estoque atual)</option>
                  <option value="recontar" disabled>Recontagem (Estoque vs Inventário - Gera ajustes caso diferença)</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="row" v-if="!updating">


        <div class="col-xl-8">

          <b-card-text>
            <div class="card">
              <div class="card-body"

              >
                <!--              <h4 class="card-title">Informações Principais</h4>-->
                <!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

                <form class="needs-validation">
                  <div class="row">


                    <div class="col-md-4">
                      <div class="mb-3">
                        <div class="mb-2">
                          <span class="text-black font-18 ">Endereço</span>
                        </div>

                        <multiselect id="endereco"
                                     ref="endwms"
                                     @search-change="pesqEndereco"
                                     @select="escolheuEndereco"
                                     v-model="movInventItemData.endwms"
                                     placeholder="Pesquisar endereços"
                                     :options="dtlistPesqEndereco"
                                     :searchable="true"
                                     :disabled="movInventData.status !== 'EL'"
                                     label="descricao"
                                     track-by="descricao"
                                     value-prop="descricao">
                          <template #option="slotProps">
                            <div class="row">
                              <div>
                              <span class="text-info">
                                {{ slotProps.option.codigo }}
                              </span>
                                <span class="mx-4" >
                                {{ slotProps.option.endereco }}
                              </span>
                              </div>
                              <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                              <span class="mx-4" >
                              </span>
                              <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                            </div>
                          </template>
                        </multiselect>

                      </div>

                    </div>


                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="lote">Lote</label>
                        <input
                            id="lote"
                            v-model="movInventItemData.lote"
                            type="text"
                            ref="lote"
                            class="form-control"
                            :disabled="movInventData.status !== 'EL' || movInventData.deflote === 'I'"
                            @keypress.enter="informouLote"/>

                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="valid">Validade:</label>
                        <input
                            id="valid"
                            v-model="movInventItemData.dtvalid"
                            type="date"
                            ref="valid"
                            class="form-control"
                            placeholder="Definir Valid"
                            :disabled="movInventData.status !== 'EL' || movInventData.defvalid === 'I'"
                            @change="informouValid"/>
                      </div>
                    </div>


                    <div class="col-sm-6">
                      <div class="mb-3">
                        <label for="produto">Código|EAN do Item</label>
                        <input
                            id="produto"
                            v-model="movInventItemData.produto"
                            type="text"
                            ref="produto"
                            class="form-control"
                            placeholder="Produto (alt + S)"
                            @keypress.enter="informouProduto"
                            :disabled="movInventData.status !== 'EL'"
                            :class="{'is-invalid': submitted && !movInventItemData.produto}"/>
                        <div v-if="submitted && !movInventItemData.produto"
                             class="invalid-feedback">
                          <span>Campo produto obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>




                    <div class="col-sm-3">
                      <div class="mb-3">
                        <label for="qtd">Quantidade </label>
                        <input
                            id="qtd"
                            ref="qtd"
                            v-model="movInventItemData.qtd"
                            type="number"
                            class="form-control"
                            :disabled="movInventData.tipoconf === 'A' || movInventData.status !== 'EL'"
                            @keypress.enter="informouQtd"
                            placeholder="Quantidade a ser lida"/>
                      </div>
                    </div>


                    <div class="col-sm-6">
                      <!--                    <div class="mb-3">-->
                      <!--                      <label for="qtd">Quantidade de Itens</label>-->
                      <!--                      <input-->
                      <!--                          id="qtd"-->
                      <!--                          v-model="movInventItemData.qtd"-->
                      <!--                          type="number"-->
                      <!--                          :disabled="true"-->
                      <!--                          class="form-control"-->
                      <!--                          placeholder="Quantidade de Itens"/>-->
                      <!--                    </div>-->
                    </div>



                    <div class="col-sm-6">
                      <div class="mb-3 align-items-end align-content-end float-end">
                        <h5 class="font-size-14">Conferência</h5>
                        <b-form-checkbox
                            switch size="lg"
                            value="A"
                            unchecked-value="I"
                            :disabled="movInventData.status !== 'EL'"
                            v-model="movInventData.tipoconf">
                          {{ movInventData.tipoconf === 'A' ? 'Auto' : 'Manual' }}
                        </b-form-checkbox>
                      </div>
                    </div>



                    <div class="row">


                      <div class="col-sm-9">
                        <div class="mb-3">
                          <label for="descprod">Descrição Produto</label>
                          <input
                              id="descprod"
                              v-model="movInventItemData.descprod"
                              type="text"
                              :disabled="true"
                              class="form-control"
                              placeholder="Descrição Produto"/>
                        </div>
                      </div>


                      <div class="col-sm-3">
                        <div class="mb-3">
                          <label for="saldo">Saldo</label>
                          <input
                              id="saldo"
                              v-model="movInventItemData.saldo"
                              type="number"
                              :disabled="true"
                              class="form-control text-end"
                              placeholder="Saldo"/>
                        </div>
                      </div>


                    </div>




                  </div>

                </form>


                <Loader v-if="updatingListas" style="min-height: 200px;">
                </Loader>



              </div>
            </div>

          </b-card-text>


        </div>


        <div class="col-xl-4">

          <Loader v-if="updatingPesqProd" style="min-height: 200px;">
          </Loader>

          <b-card-text v-if="dtListProdSugest !== null && dtListProdSugest.length > 0">
            <div class="card">
              <div class="card-body">
                <!--              <h4 class="card-title">Informações Principais</h4>-->
                <!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

                <div class="row mb-2">

                  <h4 class="card-title">Produtos pesquisa ({{ dtListProdSugest !== null ? dtListProdSugest.length : 0 }})</h4>

                  <div class="table-responsive" v-if="!updatingPesqProd">
                    <table class="table align-middle mb-0 table-nowrap">
                      <thead class="table-light">
                      <tr>
                        <th>Produto</th>
                        <th>Descrição</th>
                      </tr>
                      </thead>
                      <tbody>

                      <tr v-for="data in dtListProdSugest" :key="data.id">

                        <td>

                          <img v-if="data.img1"
                               :src="data.img1"
                               alt="product-img"
                               title="product-img"
                               class="avatar-md" />

                          <div class="mb-3" v-else>
                            <i class="bx bxs-camera-off h2 text-warning" title="Produto sem foto"></i>
                          </div>

                        </td>

                        <td>
                          <h5 class="font-size-12 text-truncate">
                            <a href="javascript: void(0);" @click="selecionarPesq(data)" class="text-body fw-bold text-wrap">
                              {{ data.descricao }}
                            </a>
                          </h5>


                          <h6 class="text-muted mb-0">Sku: {{ data.codigo  }}


                          </h6>


                          <h6 class="text-black-50 mb-0">{{ data.unidade  }} </h6>
                          <h5 class="font-size-12 text-truncate text-end">

                          </h5>

                          <h6 class="text-muted mb-0"> {{ data.codbarra  }} </h6>


                          <h5 class="font-size-12 text-truncate text-end">
                            <b-button variant="outline-success" @click="selecionarPesq(data)">
                              <i class="mdi mdi-check d-block font-size-16"></i>
                            </b-button>
                          </h5>
                        </td>


                      </tr>



                      </tbody>
                    </table>
                  </div>

                </div>

              </div>
            </div>

          </b-card-text>


        </div>


      </div>



      <div class="row" v-if="!updating">

        <div class="col-xl-8">

          <b-card-text>
            <div class="card">
              <div class="card-body">
                <!--              <h4 class="card-title">Informações Principais</h4>-->
                <!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

                <div class="row mb-2">

                  <Loader v-if="updatingListas" style="min-height: 200px;">
                  </Loader>

                  <h4 class="card-title">Produtos do inventário ({{ movInventItensData !== null ? movInventItensData.length : 0 }})</h4>

                  <div class="table-responsive" v-if="!updatingListas">
                    <table class="table align-middle mb-0 table-nowrap">
                      <thead class="table-light">
                      <tr>
                        <th>Produto</th>
                        <th>Descrição</th>
                        <th>Endereço</th>
                        <th>Lote</th>
                        <th class="text-end">Quantidade</th>
                        <th class="text-end">Ações</th>
                      </tr>
                      </thead>
                      <tbody>

                      <tr v-for="data in movInventItensData" :key="data.id">

                        <td>
                          <h6 class="text-muted mb-0">{{ data.produto  }} </h6>
                          <img v-if="data.img1"
                               :src="data.img1"
                               alt="product-img"
                               title="product-img"
                               class="avatar-md" />

                          <div class="mb-3" v-else>
                            <i class="bx bxs-camera-off h2 text-warning" title="Produto sem foto"></i>
                          </div>

                        </td>

                        <td>
                          <h5 v-if="movInventData.status === 'EL'" class="font-size-12 text-truncate">
                            <a href="javascript: void(0);"  @click="editarProd(data)" class="text-body fw-bold text-wrap">
                              {{ data.descprod }}
                            </a>
                          </h5>
                          <h5 v-else class="font-size-12 text-truncate">
                            {{ data.descprod }}
                          </h5>
                        </td>

                        <td>
                          <h5 class="font-size-12 text-truncate">
                            {{ data.endwms }}
                          </h5>
                        </td>

                        <td>
                          <h5 class="font-size-12 text-truncate">
                            {{ data.lote }}
                          </h5>
                        </td>

                        <td>
                          <h5 class="font-size-12 text-truncate text-end">
                            {{ formatDecimal(data.qtd) }}
                          </h5>
                        </td>

                        <td>
                          <h5 class="font-size-12 text-truncate text-end" v-if="movInventData.status === 'EL'">
                            <b-button variant="outline-danger" @click="deletarItem(data.id)">
                              <i class="mdi mdi-trash-can d-block font-size-16"></i>
                            </b-button>
                          </h5>
                        </td>

                      </tr>



                      </tbody>
                    </table>
                  </div>

                </div>

              </div>
            </div>

          </b-card-text>


        </div>

      </div>


    </Layout>
  </div>

  <div class="col-lg-12 full-height-wrapper" v-if="!updating && tamanhoTela < 500">

    <div class="card full-height-card">
      <div class="card-body full-height-body">

        <div class="row">
          <div class="d-flex col-10 align-items-baseline" style="position: fixed; top: 10px; left: 5px; z-index: 1000;">
            <h5 class="me-1">Inventário</h5>
            <label :class="movInventData.status === 'FE' ? 'badge badge-soft-success' : 'badge badge-soft-info'"

            >
              {{ nomeStatusInvent(movInventData.status) }}
            </label>
          </div>


          <button title="Retornar para input Invent" @click="retornaParaInputInvent" class="btn col-1 p-1 m-1 border-0 font-size-16"
                  style="position: fixed; top: 0px; right: 5px; background-color: white; z-index: 1000;"
          >
            <i class="bx bx-undo"></i>
          </button>

          <div class="d-flex justify-content-between"  style="margin-top: 12px">

            <button class="btn p-1 m-1 border-0 font-size-16" @click="atualizaPagina" :disabled="this.movInventItemData?.length > 0">
              <i class="bx bx-sync"></i>
            </button>

            <button type="button" class="btn p-1 m-1 border-0 font-size-16"
                    @click="salvar" :disabled="movInventData.status === 'FE'">
              <i class="bx bx-save"></i>
            </button>

            <button type="button" class="btn p-1 m-1 border-0 font-size-16"
                    @click="abrirShowListInvent" :disabled="idData !== 0 && activeStep !== 3">
              <i class="bx bx-list-ul"></i>
            </button>

            <button type="button" class="btn p-1 m-1 border-0 font-size-16"
                    :disabled="movInventData.status === 'FE'" @click="showListConfiguracoes = true">
              <i class="bx bx-layer "></i>
            </button>

            <button type="button" class="btn p-1 m-1 border-0 font-size-14" @click="initFullScreen">
              <i class="bx bx-fullscreen"></i>
            </button>

          </div>
        </div>


        <form class="needs-validation">
          <div id="step0" v-if="activeStep === 0 && idData > 0 " class="row">
            <div class="col-sm-12">
              <div class="mb-3">
                <label for="inventID">Inventário(ID)</label>
                <input id="inventID" v-model="movInventData.id"
                       type="text"
                       class="form-control"
                       placeholder="Entre com o ID do inventário"
                       disabled
                       ref="inventID"
                       />
              </div>
            </div>

            <div class="nav-buttons">
              <button type="button" disabled class="btn-nav btn-back">
                Voltar
              </button>
              <button type="button" class="btn-nav btn-next" @click="goToStep(2)">
                Próximo
              </button>
            </div>
          </div>

          <div id="step1" v-if="idData === 0 && activeStep === 1" class="row mb-4">
            <div v-if="idData === 0" class="col-sm-12 mb-5">
              <div class="mb-3">
                <label for="inventID">Inventário(ID)</label>
                <input
                    id="inventID"
                    v-model="movInventData.id"
                    type="text"
                    class="form-control compact-input"
                    placeholder="Entre com o ID do inventário"
                    ref="inventID"
                    @keydown.enter.prevent="carregarInvent"
                />
              </div>

            </div>

            <div class="nav-buttons">
              <button type="button" disabled class="btn-nav btn-back">
                Voltar
              </button>
              <button type="button" class="btn-nav btn-next" @click="carregarInvent">
                Próximo
              </button>
            </div>
          </div>

          <div id="step2" v-if="idData > 0 && activeStep === 2" class="row">
            <div class="col-sm-12">
              <div class="mb-2">
                <label for="endereco">Endereço de Estoque</label>
                <input id="endereco" v-if="movInventData.tipoendwms === 'A'"
                       ref="endwms"
                       v-model="movInventItemData.endwms"
                       type="text"
                       class="form-control compact-input"
                       placeholder="Definir Endereço"
                       @keydown.enter.prevent="escolheuEndereco" />

                <multiselect id="endereco" v-else
                             ref="endwms"
                             @search-change="pesqEndereco"
                             @select="escolheuEndereco"
                             v-model="movInventItemData.endwms"
                             placeholder="Pesquisar endereços"
                             :options="dtlistPesqEndereco"
                             :searchable="true"
                             :disabled="movInventData.status !== 'EL'"
                             label="descricao"
                             track-by="descricao"
                             value-prop="descricao">
                  <template #option="slotProps">
                    <div class="row">
                      <div class="font-size-12">
                        <span class="text-info">
                          {{ slotProps.option.id }}
                        </span>
                        <span class="mx-4" >
                            {{ slotProps.option.descricao }}
                          </span>
                      </div>
                      <div class="align-items-end text-end align-content-end font-size-12 text-muted">
                        {{ formatDateTime(slotProps.option.created_at) }}
                      </div>
                    </div>
                  </template>
                </multiselect>

              </div>

            </div>

            <div class="row mb-2" v-if="movInventData.codigo > 0 && selectedItem">

              <div class="table-responsive">
                <table class="table align-middle mb-0 table-nowrap">
                  <thead>
                  <tr>
                    <td style="padding: 0px 2px">Sku</td>
                    <td class="text-danger" style="padding: 0px 2px">Pend.</td>
                    <td class="text-success" style="padding: 0px 2px">Conf.</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="selectedItem.id">
                    <td>
                      <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                         @click="clicouProduto(selectedItem.produto)">
                        <h6 class="text-muted mb-0">{{ selectedItem.produto }} </h6>

                      </a>
                    </td>
                    <td class="text-danger">{{ selectedItem.qtddisp }}</td>
                    <td class="text-success">{{ selectedItem.qtdlida }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="nav-buttons">
              <button type="button" class="btn-nav btn-back" @click="goToStep(0)" >
                Voltar
              </button>
              <button type="button" class="btn-nav btn-next" @click="escolheuEndereco">
                Iniciar Leitura
              </button>
            </div>
          </div>

          <div id="step3" v-if="idData > 0 && activeStep === 3" class="row">
            <div class="col-sm-12">
              <div class="row mb-1">
                <div class="col-6">
                  <span>End.: </span>
                  <label v-if=" movInventItemData.endwms" for="endereco">
                    {{  movInventItemData.endwms }}
                  </label>
                </div>
              </div>

              <div class="row">
                <div class="col-6 mb-3">
                  <label for="lote">Lote</label>
                  <input
                      id="lote"
                      v-model="movInventItemData.lote"
                      type="text"
                      ref="lote"
                      class="form-control compact-input"
                      placeholder="Definir Lote"
                      :disabled="movInventData.status !== 'EL' || movInventData.deflote === 'I'"
                      @keypress.enter="informouLote"/>

                </div>

                <div class="col-6 mb-3">
                  <label for="valid">Validade:</label>
                  <input
                      id="valid"
                      v-model="movInventItemData.dtvalid"
                      type="date"
                      ref="valid"
                      class="form-control compact-input"
                      placeholder="Definir Valid"
                      :disabled="movInventData.status !== 'EL' || movInventData.defvalid === 'I'"
                      @change="informouValid"/>
                </div>
              </div>

              <div class="mb-2">
                <label for="produto">Código|EAN do Item</label>
                <input
                    id="produto"
                    v-model="movInventItemData.produto"
                    type="text"
                    ref="produto"
                    class="form-control compact-input"
                    placeholder="Produto (alt + S)"
                    @keypress.enter="informouProduto"
                    :disabled="movInventData.status !== 'EL'"
                    :class="{'is-invalid': submitted && !movInventItemData.produto}"/>
                <div v-if="submitted && !movInventItemData.produto"
                     class="invalid-feedback">
                  <span>Campo produto obrigatório, favor preencher.</span>
                </div>
              </div>

              <div class="mb-3">
                <label for="qtd">Quantidade </label>
                <input
                    id="qtd"
                    ref="qtd"
                    v-model="movInventItemData.qtd"
                    type="number"
                    class="form-control compact-input"
                    :disabled="movInventData.tipoconf === 'A' || movInventData.status !== 'EL'"
                    @keypress.enter="informouQtd"
                    placeholder="Quantidade a ser lida"/>
              </div>

            </div>

            <div class="nav-buttons">
              <button type="button" class="btn-nav btn-back" @click="goToStep(2)" >
                Endereço/Lote
              </button>
              <button type="button" class="btn-nav btn-next" @click="goToStep(2)">
                Finalizar Leitura
              </button>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>

  <b-modal title="Confer. Manual" v-model="showConfManual" @shown="onModalConfManual" centered hide-footer>
    <div class="col-md-12">

      <!--                  Modal para colocar itens quando conf. for manual-->

      <div class="col-sm-6" v-if="selectedItem?.id">
        <div class="mb-3">
          <label for="codprod">Código do Item</label>
          <input id="codprod" v-model="selectedItem.produto" type="text" class="form-control"
                 disabled />
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <label for="qtd">Qtd. Itens</label>
          <input id="qtd" v-model="wmsOsItemData.qtd" type="number" :disabled="true" class="form-control"
                 placeholder="Quantidade de Itens" />
        </div>

        <div class="col-6">
          <label for="qtdlida">Qtd. Disp.</label>
          <input id="qtdlida" ref="qtdlida" v-model="wmsOsItemData.qtdlida" type="number"
                 class="form-control" :disabled="movInventData.tipoconf === 'A'" @keypress.enter="informouQtdLida"
                 placeholder="Quantidade a ser lida" />
        </div>
      </div>

      <div class="row justify-content-around mt-3">
        <b-button class="col-5 btn-sm py-1" variant="light" @click="showConfManual = false">
          <i class="bx bx-block font-size-14 align-middle me-1"></i>
          <span class="small">Cancelar</span>
        </b-button>
        <b-button type="submit" variant="success" class="col-5 btn-sm py-1"
                  @click="informouQtdLida()">
          <i class="bx bx-check-double font-size-14 align-middle me-1"></i>
          <span class="small">Confirmar</span>
        </b-button>
      </div>
    </div>

  </b-modal>

  <b-modal title="Itens Inventariados " v-model="showItensInvent" @hidden="onModalClosed" centered hide-footer>
    <div class="col-md-12">

      <div class="table-responsive">
        <table class="table align-middle mb-0 table-nowrap">
          <thead class="table-light">
          <tr>
            <th>Produto</th>
            <th class="text-end">Endereço</th>
            <th class="text-end">Qtd.</th>
          </tr>
          </thead>
          <tbody>

          <template v-for="(data, index) in movInventItensData" :key="data.id">
            <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
              <td style="padding-top: 3px; padding-bottom: 3px; max-width: 12px;word-wrap: break-word;
                overflow-wrap: break-word; white-space: normal;">
                <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                   @click="clicouProduto(data.produto)">
                  {{ data.produto }}
                </a>
              </td>

              <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ data.endwms }}</td>
              <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDecimal(data.qtd) }}</td>
            </tr>
            <tr v-if="data.deflote" :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
              <td colspan="3" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                Lote: {{ data.lote ?? 'Não Definido' }}
              </td>
            </tr>
            <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
              <td colspan="3" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                {{ data.descprod.length > 25 ? data.descprod.substring(0, 25) + '...' : data.descprod }}
              </td>
            </tr>
            <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
              <td colspan="3" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                <span class="me-3"> {{  'Lote: ' + data.lote ?? '' }} </span>
                <span> {{'Dt.Valid: ' + data.dtvalid ?? ''}} </span>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>

  </b-modal>

  <b-modal title="Configurações" v-model="showListConfiguracoes" @hidden="closedModalConfig()" centered hide-footer>
    <div class="col-md-12">

      <div class="col-12 text-center">
        <button type="button" class="btn-nav btn-next"
                :disabled="movInventItemData?.length < 1"
                @click="confirmarInvent"
        >
          <i class="mdi mdi-check me-1 text-end"></i>
          Finalizar Inventário
        </button>
      </div>

      <hr>

      <div class="col-12">
        <div class="mb-2">
          <label for="tipo">Tipo de inventário</label> <!--:disabled="movInventData.status !== 'EL'"-->
          <select id="tipo" v-model="movInventData.tipo" class="form-control mb-1 py-1"
          >
            <option value="sobrepor">Sobreposição</option>
            <option value="soma">Soma</option>
            <option value="recontar" disabled>Recontagem</option>
          </select>
          <span v-if="movInventData.tipo === 'sobrepor'" class="font-size-10">
            <strong>Sobreposição: </strong> Zera histório e recomeça com inventário.
          </span>
          <span v-else-if="movInventData.tipo === 'soma'" class="font-size-10">
            <strong>Soma: </strong> Acréscimo ao estoque atual.
          </span>
          <span v-else-if="movInventData.tipo === 'recontar'" class="font-size-10">
            <strong>Recontagem: </strong> Estoque vs Inventário - Gera ajustes caso diferença.
          </span>
        </div>
      </div>


      <hr>

      <div class="col-12 mb-1 d-flex justify-content-start">
        <b-form-checkbox switch size="md" value="A" unchecked-value="I" v-model="movInventData.tipoendwms">
          {{ movInventData.tipoendwms === 'A' ? 'End. Tipo Input' : 'End. Tipo Multiselect' }}
        </b-form-checkbox>
      </div>
      <div class="col-12 d-flex justify-content-start">
        <b-form-checkbox switch size="md" value="A" unchecked-value="I" v-model="movInventData.tipoconf">
          {{ movInventData.tipoconf === 'A' ? 'Conf. Auto' : 'Conf. Manual' }}
        </b-form-checkbox>
      </div>
      <div class="col-12 d-flex justify-content-start">
        <b-form-checkbox switch size="md" value="A" unchecked-value="I" v-model="movInventData.deflote">
          {{ movInventData.deflote === 'A' ? 'Definir Lote' : 'Desconsidera Lote' }}
        </b-form-checkbox>
      </div>
      <div class="col-12 d-flex justify-content-start">
        <b-form-checkbox switch size="md" value="A" unchecked-value="I" v-model="movInventData.defvalid">
          {{ movInventData.defvalid === 'A' ? 'Definir Validade' : 'Desconsidera Validade' }}
        </b-form-checkbox>
      </div>

    </div>

  </b-modal>

  <b-modal title="Lista de Inventários" v-model="showListInvents" centered hide-footer>
    <div class="col-md-12">

      <div class="table-responsive">
        <table class="table align-middle mb-0 table-nowrap">
          <thead class="table-light">
          <tr>
            <th class="text-center" style="padding-top: 3px; padding-bottom: 3px;">ID</th>
            <th class="text-start" style="padding-top: 3px; padding-bottom: 3px;">Empresa</th>
<!--            <th class="text-end" style="white-space: normal; max-width: 5px; padding-top: 3px; padding-bottom: 3px;">Dt. Emissão</th>-->
          </tr>
          </thead>
          <tbody>

          <template v-for="(data, index) in movInventsData" :key="data.id">
            <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
              <td class="text-center" style="padding-top: 3px; padding-bottom: 3px;">
                <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                   @click="clicouInvent(data.id)"
                >
                  {{ data.id }}
                </a>
              </td>

              <td class="text-start" style="padding-top: 3px; padding-bottom: 3px;">
                <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                   @click="clicouInvent(data.id)"
                >
                  {{ data.empresa_nome.length > 15 ? data.empresa_nome.substring(0, 15) + '...' : data.empresa_nome }}
                </a>
              </td>
<!--              <td class="text-end" style="padding-top: 3px; padding-bottom: 3px;">{{ formatDate(data.dtemissao) }}</td>-->
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>

  </b-modal>

  <b-modal
      v-model="showModalErros"
      id="showModalErros"
      size="lg"
      title="Erros gerados na ação"
      title-class="font-18"
      hide-footer
      @hide="carregarDados"
  >
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead class="table-light">
                <tr>
                  <th>Erro</th>
                  <th>ID Produto</th>
                  <th>Código Produto</th>
                  <th>Nome Produto</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in dtListErrors" :key="data.id">
                  <td>{{data.error}}</td>
                  <td>{{data.produto_id}}</td>
                  <td>{{data.produto_cod}}</td>
                  <td>{{data.produto_desc}}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <br><br>
            <!--<div class="d-flex">
              <div>
                <h6>Deseja criar um novo ajuste para alteração da quantidade?</h6>
                <h6 class="text-danger">Nova quantidade de itens será a disponível em estoque!</h6>
              </div>
              <b-button type="submit" variant="success" class="mx-2" @click="criarNovoMovAjt">
                <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                Confirmar
              </b-button>
              <b-button type="submit" variant="danger" class="mx-2" @click="cancelaNovoAjt">
                <i class="bx bx-x font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<style scoped>
.full-height-wrapper {
  height: 100vh;
  overflow: hidden;
}

.full-height-card {
  height: 100%;
  margin-bottom: 0;
  border-radius: 0;
}

.full-height-body {
  height: 100%;
  overflow: hidden;
}


.btn-compact {
  background: none;
  border: 1px solid #ddd;
  padding: 3px 6px;
  border-radius: 3px;
  font-size: 12px;
  min-width: 28px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-compact:hover {
  background-color: #f5f5f5;
}

.compact-input {
  font-size: 12px;
  padding: 4px 6px;
  height: 32px;
  border-radius: 3px;
  border: 1px solid #ddd;
  width: 100%;
}

.compact-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 1px rgba(0,123,255,.25);
  outline: none;
}

.compact-input.is-invalid {
  border-color: #dc3545;
}

.error-msg {
  font-size: 9px;
  color: #dc3545;
  margin-top: 2px;
}

.client-info {
  background: #f8f9fa;
  padding: 4px 6px;
  border-radius: 3px;
  margin-bottom: 6px;
  font-size: 10px;
}

.client-name {
  font-weight: 600;
  display: block;
  color: #333;
  line-height: 1.2;
}

.client-detail {
  color: #666;
  font-size: 9px;
}

.item-info {
  background: #e8f4f8;
  padding: 4px 6px;
  border-radius: 3px;
  margin-bottom: 8px;
  font-size: 10px;
}

.item-row {
  display: flex;
  justify-content: space-between;
  line-height: 1.3;
}

.item-label {
  font-weight: 600;
  color: #555;
}

.item-value {
  color: #333;
  font-weight: 500;
}

.nav-buttons {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #ddd;
  z-index: 1000;
  gap: 6px;
}

.btn-nav {
  flex: 1;
  padding: 6px 4px;
  font-size: 10px;
  font-weight: 600;
  border-radius: 3px;
  border: 1px solid;
  background: white;
  height: 28px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-back {
  border-color: #6c757d;
  color: #6c757d;
}

.btn-back:hover:not(:disabled) {
  background-color: #6c757d;
  color: white;
}

.btn-back:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-next {
  border-color: #28a745;
  color: #28a745;
}

.btn-next:hover {
  background-color: #28a745;
  color: white;
}
</style>
